import { format, startOfQuarter, endOfQuarter, subQuarters, startOfYear } from "date-fns";

const iso = (d) => format(d, "yyyy-MM-dd");

/**
 * Presets used on the Oman VAT Ledger (and reusable elsewhere).
 * Oman OTA VAT quarters follow the calendar year (Q1: Jan-Mar … Q4: Oct-Dec).
 */
export function fiscalPresets(now = new Date()) {
  const thisQ = { from: iso(startOfQuarter(now)), to: iso(endOfQuarter(now)) };
  const lastQBase = subQuarters(now, 1);
  const lastQ = { from: iso(startOfQuarter(lastQBase)), to: iso(endOfQuarter(lastQBase)) };
  const ytd = { from: iso(startOfYear(now)), to: iso(now) };
  return [
    { key: "this-q", label: "This Quarter", range: thisQ },
    { key: "last-q", label: "Last Quarter", range: lastQ },
    { key: "ytd", label: "YTD", range: ytd },
  ];
}

/**
 * Tiny chip strip that applies one of {This Quarter, Last Quarter, YTD} to the
 * caller's from/to state. `active` is highlighted when the current from/to
 * exactly matches a preset.
 */
export default function FiscalPresetChips({ from, to, onApply, testIdPrefix = "fiscal-preset" }) {
  const presets = fiscalPresets();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testIdPrefix}-chips`}>
      {presets.map((p) => {
        const active = from === p.range.from && to === p.range.to;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onApply(p.range.from, p.range.to)}
            data-testid={`${testIdPrefix}-${p.key}`}
            className={
              "text-[10px] font-mono tracking-[0.15em] uppercase px-2.5 py-1 border transition-colors " +
              (active
                ? "border-[#FF3E00] bg-[#FF3E00] text-white"
                : "border-zinc-300 bg-white text-zinc-700 hover:border-zinc-950 hover:bg-zinc-50")
            }
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
